import { DataVersion, LocationAlarm } from '@hakimo-ui/hakimo/types';
import { withDataVersion } from '@hakimo-ui/hakimo/util';
import useAuthenticatedRequest from '../shared/useAuthenticatedRequest';

export function useSingleLocationAlarm(
  locationAlarmId: string,
  refetchEvery?: number,
  partitionKey?: string,
  dataVersion?: DataVersion
) {
  const url = `/v2/orm/location_alarms/${locationAlarmId}${
    partitionKey ? `?partitionKey=${partitionKey}` : ''
  }`;
  const request = new Request(url);
  withDataVersion(request, dataVersion);

  return useAuthenticatedRequest<LocationAlarm>(request, {
    queryKey: ['locationAlarms', locationAlarmId, dataVersion],
    responseModifier: async (response) => {
      const respJson = await response.json();
      return respJson.payload;
    },
    refetchInterval: refetchEvery ?? false,
  });
}

export default useSingleLocationAlarm;
